module.exports = __webpack_public_path__ + "static/img/NICC-_Favicon-White.5ae711a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NICC-_Favicon-White.png
// module id = RZ/C
// module chunks = 1